document.addEventListener("DOMContentLoaded", () => {
  const page = document.querySelector("[data-category-page]");
  if (!page || typeof interstoneCategoryData === "undefined") return;

  const categorySlug = page.dataset.categorySlug;
  const baseUrl = page.dataset.baseUrl;

  const layout = document.querySelector("[data-filter-layout]");
  const toggleBtn = document.querySelector("[data-filter-toggle]");
  const closeBtn = document.querySelector("[data-filter-close]");
  const filtersPanel = document.getElementById("interstone-filters");
  const sortSelect = document.querySelector("[data-sort-select]");
  const perPageSelect = document.querySelector("[data-per-page-select]");
  const grid = document.querySelector("[data-product-grid]");
  const pagination = document.querySelector("[data-pagination]");
  const resultsCount = document.querySelector("[data-results-count]");
  const activeFilters = document.querySelector("[data-active-filters]");
  const loading = document.querySelector("[data-products-loading]");
  const viewBtns = document.querySelectorAll("[data-view]");

  // View toggle — always default to grid on page load
  const savedView = "grid";
  const MOBILE_BREAKPOINT = 768;

  function setView(view, animate) {
    if (!grid) return;

    const effectiveView = window.innerWidth <= MOBILE_BREAKPOINT ? "grid" : view;

    if (animate) {
      grid.style.opacity = "0";
      setTimeout(() => {
        grid.classList.toggle("is-list-view", effectiveView === "list");
        grid.style.opacity = "";
      }, 150);
    } else {
      grid.classList.toggle("is-list-view", effectiveView === "list");
    }

    viewBtns.forEach((btn) => {
      const active = btn.dataset.view === effectiveView;
      btn.classList.toggle("is-active", active);
      btn.setAttribute("aria-pressed", active ? "true" : "false");
    });

    // view is session-only, not persisted
  }

  setView(savedView, false);

  viewBtns.forEach((btn) => {
    btn.addEventListener("click", () => setView(btn.dataset.view, true));
    btn.addEventListener("keydown", (e) => {
      if (e.key === "ArrowLeft" || e.key === "ArrowRight") {
        e.preventDefault();
        const next = btn.dataset.view === "grid" ? "list" : "grid";
        setView(next, true);
        document.querySelector(`[data-view="${next}"]`)?.focus();
      }
    });
  });

  window.addEventListener("resize", () => {
    if (window.innerWidth <= MOBILE_BREAKPOINT) {
      setView("grid", false);
    }
  });

  const filterKeys = [
    "material_type",
    "country_of_origin",
    "color",
    "finish",
    "length",
    "thickness",
    "width",
  ];

  function getPerPageFromUrl() {
    const url = new URL(window.location.href);
    const pp = parseInt(url.searchParams.get("per_page") || "12", 10);
    return [12, 24, 48].includes(pp) ? pp : 12;
  }

  const state = {
    filters: getFiltersFromDom(),
    sort: sortSelect ? sortSelect.value : "",
    page: getPageFromUrl(),
    perPage: getPerPageFromUrl(),
  };

  function setToggleLabel(text) {
    if (!toggleBtn) return;
    const label = toggleBtn.querySelector("[data-filter-toggle-label]");
    if (label) {
      label.textContent = text;
    } else {
      toggleBtn.textContent = text;
    }
  }

  function openFilters() {
    if (!layout || !filtersPanel || !toggleBtn) return;
    layout.classList.add("is-filters-open");
    filtersPanel.setAttribute("aria-hidden", "false");
    toggleBtn.setAttribute("aria-expanded", "true");
    setToggleLabel("Hide Filter");
    document.body.classList.add("interstone-filters-open");
  }

  function closeFilters() {
    if (!layout || !filtersPanel || !toggleBtn) return;
    layout.classList.remove("is-filters-open");
    filtersPanel.setAttribute("aria-hidden", "true");
    toggleBtn.setAttribute("aria-expanded", "false");
    setToggleLabel("Filter");
    document.body.classList.remove("interstone-filters-open");
  }

  function getPageFromUrl() {
    const url = new URL(window.location.href);
    const pg = parseInt(url.searchParams.get("pg") || "1", 10);
    return Number.isNaN(pg) || pg < 1 ? 1 : pg;
  }

  function getFiltersFromDom() {
    const filters = {
      material_type: [],
      country_of_origin: [],
      color: [],
      finish: [],
      length: [],
      thickness: [],
      width: [],
    };

    document
      .querySelectorAll(".interstone-filter-pill-btn[data-filter-key]")
      .forEach((btn) => {
        if (btn.classList.contains("is-active")) {
          const key = btn.dataset.filterKey;
          if (filters[key]) {
            filters[key].push(btn.dataset.filterValue);
          }
        }
      });

    const activeMaterialChip = document.querySelector(
      "[data-material-chip].is-active",
    );
    if (activeMaterialChip) {
      filters.material_type = [activeMaterialChip.dataset.filterValue];
    }

    return filters;
  }

  function updateUrl() {
    const url = new URL(baseUrl);

    filterKeys.forEach((key) => {
      if (state.filters[key] && state.filters[key].length) {
        url.searchParams.set(key, state.filters[key].join(","));
      }
    });

    if (state.sort) {
      url.searchParams.set("sort", state.sort);
    }

    if (state.page > 1) {
      url.searchParams.set("pg", String(state.page));
    }

    if (state.perPage !== 12) {
      url.searchParams.set("per_page", String(state.perPage));
    } else {
      url.searchParams.delete("per_page");
    }

    window.history.pushState({}, "", url.toString());
  }

  function setLoading(isLoading) {
    if (!loading || !grid) return;

    if (isLoading) {
      grid.classList.add("is-loading");
      loading.setAttribute("aria-hidden", "false");
    } else {
      grid.classList.remove("is-loading");
      loading.setAttribute("aria-hidden", "true");
    }
  }

  function syncMaterialChipClasses() {
    document.querySelectorAll("[data-material-chip]").forEach((chip) => {
      const value = chip.dataset.filterValue;
      const isActive = state.filters.material_type.includes(value);
      chip.classList.toggle("is-active", isActive);
    });
  }

  function syncPillsFromState() {
    document
      .querySelectorAll(".interstone-filter-pill-btn[data-filter-key]")
      .forEach((btn) => {
        const key = btn.dataset.filterKey;
        const isActive =
          state.filters[key]?.includes(btn.dataset.filterValue) || false;
        btn.classList.toggle("is-active", isActive);
        btn.setAttribute("aria-pressed", isActive ? "true" : "false");
      });
  }

  function buildRequestData() {
    const formData = new FormData();

    formData.append("action", "interstone_filter_products");
    formData.append("category", categorySlug);
    formData.append("sort", state.sort);
    formData.append("pg", String(state.page));
    formData.append("per_page", String(state.perPage));
    formData.append("base_url", baseUrl);

    filterKeys.forEach((key) => {
      if (state.filters[key] && state.filters[key].length) {
        formData.append(key, state.filters[key].join(","));
      }
    });

    return formData;
  }

  // updateUrl() has already written the intended filter state to the address bar
  // by the time a request can fail, so reloading hands the same state to the
  // template's server-rendered path. Only ever reached from a user interaction,
  // so this cannot loop.
  function fallbackToServerRender() {
    window.location.reload();
  }

  let activeController = null;

  function fetchProducts() {
    setLoading(true);
    updateUrl();

    // Supersede any in-flight request. Without this, a slower earlier response
    // can land after a newer one and overwrite the grid, leaving it disagreeing
    // with the URL and the active chips.
    if (activeController) {
      activeController.abort();
    }
    const controller = new AbortController();
    activeController = controller;

    fetch(interstoneCategoryData.ajax_url, {
      method: "POST",
      body: buildRequestData(),
      signal: controller.signal,
    })
      .then((response) => response.json())
      .then((response) => {
        if (!response || !response.success || !response.data) {
          fallbackToServerRender();
          return;
        }

        if (grid) {
          grid.innerHTML = response.data.products_html;
        }

        if (pagination) {
          pagination.innerHTML = response.data.pagination_html;
        }

        if (resultsCount && response.data.results_count_html) {
          resultsCount.innerHTML = response.data.results_count_html;
        }

        if (activeFilters) {
          activeFilters.innerHTML = response.data.chips_html;
        }

        syncMaterialChipClasses();

        if (window.innerWidth < 992) {
          // keep drawer open if you want; change to closeFilters() if preferred
        }
      })
      .catch((error) => {
        // A superseded request is expected, not a failure — a newer one is
        // already in flight and will render.
        if (error.name === "AbortError") return;
        console.error("Interstone filter AJAX error:", error);
        fallbackToServerRender();
      })
      .finally(() => {
        // Only the newest request owns the spinner; a superseded one must not
        // clear it while its replacement is still loading.
        if (activeController === controller) {
          activeController = null;
          setLoading(false);
        }
      });
  }

  if (toggleBtn) {
    toggleBtn.addEventListener("click", (e) => {
      e.stopPropagation();
      if (layout.classList.contains("is-filters-open")) {
        closeFilters();
      } else {
        openFilters();
      }
    });
  }

  if (closeBtn) {
    closeBtn.addEventListener("click", closeFilters);
  }

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") {
      closeFilters();
    }
  });

  if (sortSelect) {
    sortSelect.addEventListener("change", () => {
      state.sort = sortSelect.value;
      state.page = 1;
      fetchProducts();
    });
  }

  if (perPageSelect) {
    perPageSelect.addEventListener("change", () => {
      state.perPage = parseInt(perPageSelect.value, 10) || 12;
      state.page = 1;
      fetchProducts();
    });
  }
  document
    .querySelectorAll(".interstone-filter-pill-btn[data-filter-key]")
    .forEach((btn) => {
      btn.addEventListener("click", () => {
        const key = btn.dataset.filterKey;
        const value = btn.dataset.filterValue;
        if (!state.filters[key]) state.filters[key] = [];

        if (state.filters[key].includes(value)) {
          state.filters[key] = state.filters[key].filter((v) => v !== value);
        } else {
          state.filters[key].push(value);
        }

        const isActive = state.filters[key].includes(value);
        btn.classList.toggle("is-active", isActive);
        btn.setAttribute("aria-pressed", isActive ? "true" : "false");

        state.page = 1;
        fetchProducts();
      });
    });

  document.querySelectorAll("[data-material-chip]").forEach((chip) => {
    chip.addEventListener("click", (event) => {
      event.preventDefault();

      const value = chip.dataset.filterValue;
      const isActive = state.filters.material_type.includes(value);

      state.filters.material_type = isActive ? [] : [value];
      state.page = 1;

      syncMaterialChipClasses();
      fetchProducts();
    });
  });

  document.addEventListener("click", (event) => {
    if (!event.target.closest("[data-clear-filters]")) return;
    filterKeys.forEach((key) => {
      state.filters[key] = [];
    });
    state.page = 1;
    syncPillsFromState();
    syncMaterialChipClasses();
    fetchProducts();
    closeFilters();
  });

  document.addEventListener("click", (event) => {
    const removeBtn = event.target.closest("[data-remove-filter]");
    if (!removeBtn) return;

    event.preventDefault();

    const key = removeBtn.dataset.filterKey;
    const value = removeBtn.dataset.filterValue;

    if (!state.filters[key]) return;

    state.filters[key] = state.filters[key].filter((item) => item !== value);
    state.page = 1;

    syncPillsFromState();
    syncMaterialChipClasses();
    fetchProducts();
  });

  document.addEventListener("click", (event) => {
    const pageLink = event.target.closest("[data-page-link]");
    if (!pageLink) return;

    event.preventDefault();

    state.page = parseInt(pageLink.dataset.page, 10) || 1;
    fetchProducts();

    const productsArea = document.querySelector("[data-products-area]");
    if (productsArea) {
      productsArea.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  });

  window.addEventListener("popstate", () => {
    const url = new URL(window.location.href);

    filterKeys.forEach((key) => {
      const value = url.searchParams.get(key);
      state.filters[key] = value ? value.split(",").filter(Boolean) : [];
    });

    state.sort = url.searchParams.get("sort") || "";
    state.page = parseInt(url.searchParams.get("pg") || "1", 10) || 1;
    state.perPage = getPerPageFromUrl();

    if (sortSelect) {
      sortSelect.value = state.sort;
    }

    if (perPageSelect) {
      perPageSelect.value = String(state.perPage);
    }

    syncPillsFromState();
    syncMaterialChipClasses();
    fetchProducts();
  });
});
